import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DependencyState } from './dependency.state';

export const selectDependencyState = createFeatureSelector<DependencyState>('dependency');

// Basic selectors
export const selectAllDependencies = createSelector(
  selectDependencyState,
  state => state.dependencies
);

export const selectParentDependencies = createSelector(
  selectDependencyState,
  state => state.parentDependencies
);

export const selectSelectedDependency = createSelector(
  selectDependencyState,
  state => state.selectedDependency
);

export const selectDependencyLoading = createSelector(
  selectDependencyState,
  state => state.loading
);

export const selectDependencyCreating = createSelector(
  selectDependencyState,
  state => state.creating
);

export const selectDependencyUpdating = createSelector(
  selectDependencyState,
  state => state.updating
);

export const selectDependencyToggling = createSelector(
  selectDependencyState,
  state => state.toggling
);

export const selectDependencySearching = createSelector(
  selectDependencyState,
  state => state.searching
);

export const selectDependencySearchResults = createSelector(
  selectDependencyState,
  state => state.searchResults
);

export const selectDependencyError = createSelector(selectDependencyState, state => state.error);

// Computed selectors
export const selectActiveDependencies = createSelector(selectAllDependencies, dependencies =>
  dependencies.filter(d => d.isDisponible)
);

export const selectInactiveDependencies = createSelector(selectAllDependencies, dependencies =>
  dependencies.filter(d => !d.isDisponible)
);

export const selectDependenciesWithoutParent = createSelector(selectAllDependencies, dependencies =>
  dependencies.filter(d => d.padreId === null)
);

export const selectDependenciesWithParent = createSelector(selectAllDependencies, dependencies =>
  dependencies.filter(d => d.padreId !== null)
);

export const selectDependencyById = (id: number) =>
  createSelector(selectAllDependencies, dependencies =>
    dependencies.find(d => d.dependenciaId === id)
  );

export const selectChildDependencies = (parentId: number) =>
  createSelector(selectAllDependencies, dependencies =>
    dependencies.filter(d => d.padreId === parentId)
  );

export const selectDependenciesCount = createSelector(
  selectAllDependencies,
  dependencies => dependencies.length
);

export const selectActiveDependenciesCount = createSelector(
  selectActiveDependencies,
  dependencies => dependencies.length
);

export const selectInactiveDependenciesCount = createSelector(
  selectInactiveDependencies,
  dependencies => dependencies.length
);
